import { render, staticRenderFns } from "./ArtistInfo.vue?vue&type=template&id=202ed410&scoped=true&"
import script from "./ArtistInfo.vue?vue&type=script&lang=js&"
export * from "./ArtistInfo.vue?vue&type=script&lang=js&"
import style0 from "./ArtistInfo.vue?vue&type=style&index=0&id=202ed410&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202ed410",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VIcon,VImg,VLayout})
